import type { Rolle } from "./modell.ts";

export type Recht = "lesen" | "notiz" | "bearbeiten" | "struktur" | "katalog" | "freigeben" | "texturen" | "konten";

const LESER: Recht[] = ["lesen", "notiz"];
const BEARBEITER: Recht[] = [...LESER, "bearbeiten"];
const ADMIN: Recht[] = [...BEARBEITER, "struktur", "katalog", "freigeben", "texturen"];
const RECHTE: Record<Rolle, Recht[]> = {
  leser: LESER,
  bearbeiter: BEARBEITER,
  admin: ADMIN,
  eigentuemer: [...ADMIN, "konten"],
};

export function darf(rolle: Rolle, recht: Recht): boolean {
  return RECHTE[rolle].includes(recht);
}

export const ROLLEN_ANZEIGE: Record<Rolle, string> = { eigentuemer: "Eigentümer", admin: "Admin", bearbeiter: "Bearbeiter", leser: "Leser" };
